import { combineReducers } from 'redux';

import { createRequestStateReducer } from '../helpers';
import { mysqlActions } from './actions';

export const mysqlReducer = combineReducers({
  websiteMySQLUsers: createRequestStateReducer(mysqlActions.getWebsiteMySQLUsers),
});
